import { call, put, takeEvery } from "redux-saga/effects";
import {  toast } from 'react-toastify';
import store from "redux/store";
import { getProfile } from "redux/actions/UserProfile";
import { profileApi, updateProfileApi } from "services/ProfileService";
import { GET_PROFILE_FAILED, GET_PROFILE_REQUESTED, GET_PROFILE_SUCCESS, GET_UPDATEPROFILE_FAILED, GET_UPDATEPROFILE_REQUESTED, GET_UPDATEPROFILE_SUCCESS } from "resources/actionTypes";
import { onLoaderTrigger } from "redux/actions/CommonAction";

function* fetchProfile(action) {
  try {
    const userProfile = yield call(profileApi);
    yield put({ type: GET_PROFILE_SUCCESS, userProfile: userProfile });
    if(userProfile?.success){

      store.dispatch(onLoaderTrigger(false));

      localStorage.setItem('role',userProfile?.data?.companyType);
      localStorage.setItem('companyId', userProfile?.data?.companyId);
      localStorage.setItem('companyName', userProfile?.data?.companyName);
      localStorage.setItem('location', userProfile?.data?.location);
      localStorage.setItem('status', userProfile?.data?.status);
      localStorage.setItem('serviceRegion', userProfile?.data?.serviceRegion);
      localStorage.setItem('parentCompany', userProfile?.data?.parentCompanyName);

    }
  } catch (e) {
    yield put({ type: GET_PROFILE_FAILED, message: e.message });
    toast.error(e.message || 'Get Profile Failed')
    store.dispatch(onLoaderTrigger(false));
  }
}

export function* profileSaga() {
  yield takeEvery(GET_PROFILE_REQUESTED, fetchProfile);
}

function* fetchUpdateProfile(action) {
  const payload = action.payload || {}
  store.dispatch(onLoaderTrigger(true));
  const userUpdateProfile = yield call(updateProfileApi, payload.userUpdateProfile);
  if(userUpdateProfile.success){
    yield put({ type: GET_UPDATEPROFILE_SUCCESS, userUpdateProfile: userUpdateProfile });
    toast.success(userUpdateProfile.message);
    store.dispatch(onLoaderTrigger(false));
    store.dispatch(getProfile());
  }else{
    store.dispatch(onLoaderTrigger(false));
    yield put({ type: GET_UPDATEPROFILE_FAILED, message: userUpdateProfile.message });
      toast.error(userUpdateProfile.message || 'Update Profile failed');
  }
}
export function* updateProfileSaga() {
  yield takeEvery(GET_UPDATEPROFILE_REQUESTED, fetchUpdateProfile);

}
